<template>
  <div
    class="mr-2 chip-holder flex flex-col"
    :class="[{ focused: focused } ]"
  >
    <div class="w-full px-2 pt-1 flex flex-wrap content-center form-control">
      <div
        v-for="(value, index) in values"
        :key="index"
        class="badge px-2 mr-1 self-stretch mb-1"
        :class="value.valid ? 'purple' : 'red'"
      >
        {{ value.value }}
        <button class="align-middle ml-1" @click="handleRemove(index)">
          <CloseIcon />
        </button>
      </div>
      <input
        ref="input"
        v-model.trim="input"
        type="text"
        class="form-input no-border flex-1 self-stretch mb-1"
        :placeholder="$t('Enter email addresses (divided by empty space or comma)')"
        @keyup.space="handleInput"
        @keyup.enter="handleInput"
        @keydown.delete="deleteInput"
        @focus="handleFocus"
        @blur="handleBlur"
      >
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import CloseIcon from '@/_legacy/components/Icons/SmallClose.vue';

  export default {
    name: 'ChipField',

    components: { CloseIcon },

    props: {
      validationRule: {
        type: [RegExp, String],
        default: null,
      },
      invalidValues: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        input: '',
        values: [],
        focused: false,
      };
    },

    watch: {
      values: {
        deep: true,
        handler: 'emitChange',
        immediate: false,
      },
      invalidValues: {
        deep: true,
        handler: 'setInvalid',
        immediate: false,
      },
    },

    created() {
      this.$parent.$on('reset', this.resetValues);
    },

    methods: {
      setInvalid() {
        _.map(this.invalidValues, invalid => {
          const val = _.find(this.values, value => value.value === invalid.value);
          if (val && val.valid) {
            val.valid = false;
          }
        });
      },
      resetValues() {
        this.values = [];
      },

      handleInput({ target }) {
        const input = target.value.trim();
        let values = input.split(/[\s,]+/)
          .map(value => value.trim())
          .filter(value => value !== '');

        values = values.filter(value => this.values.indexOf(value) === -1);
        values = values.map(value => ({
          value,
          valid: this.isValid(value),
        }));
        if (values.length) {
          this.values = this.values.concat(values);
          this.$emit('values-added', values);
        }
        this.input = '';
      },

      deleteInput() {
        if (this.input === '' && this.values.length) {
          const deleted = this.values.pop();
          this.$emit('value-deleted', deleted);
        }
      },

      handleFocus() {
        this.focused = true;
      },

      handleBlur(event) {
        this.handleInput(event);
        this.focused = false;
      },

      handleRemove(index) {
        const deleted = this.values.splice(index, 1);
        this.$emit('value-deleted', deleted);
        this.$refs.input.focus();
      },

      isValid(value) {
        if (this.validationRule && !this.validationRule.test(value)) {
          this.$emit('invalid-value', value);
          return false;
        }
        return true;
      },

      emitChange() {
        this.$emit('update', this.values);
      },
    },
  };
</script>
